import React, { useState, useEffect } from 'react';
import { Paper, Title, Table, Button, Group, Text, ScrollArea } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export default function AiLogsViewer({ user, apiBaseUrl }) {
  const { t } = useTranslation();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLogs = () => {
    if (!user) return;
    setLoading(true);
    fetch(`${apiBaseUrl}/api/admin/ai-logs?ownerEmail=${user.email}`)
      .then(res => res.json())
      .then(data => {
        setLogs(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchLogs();
  }, [user]);

  const handleClear = () => {
    if (!window.confirm(t('admin_confirm_clear_stats', 'Czy na pewno chcesz usunąć wszystkie statystyki zużycia i logi? To nieodwracalna akcja.'))) return;
    
    fetch(`${apiBaseUrl}/api/admin/ai-logs/clear`, {
      method: 'DELETE'
    })
      .then(res => res.json())
      .then(data => {
        alert(data.message);
        fetchLogs();
      })
      .catch(console.error);
  };

  if (!user) {
    return null;
  }

  return (
    <Paper p="md" withBorder shadow="sm" mt="xl">
      <Group justify="space-between" mb="md">
        <Title order={3}>{t('admin_ai_logs_title', 'Logi Zużycia AI (Zewnętrzne API)')}</Title>
        {user?.role?.includes('ADMIN') && (
          <Button 
            variant="filled" color="red" 
            leftSection={<IconTrash size={16} />}
            onClick={handleClear}
          >
            {t('admin_ai_clear_btn', 'Wykasuj Statystyki')}
          </Button>
        )}
      </Group>

      <ScrollArea h={400}>
        <Table highlightOnHover striped>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>{t('admin_ai_date', 'Data i Czas')}</Table.Th>
              <Table.Th>{t('admin_ai_user', 'Użytkownik')}</Table.Th>
              <Table.Th>{t('admin_ai_model', 'Model')}</Table.Th>
              <Table.Th>{t('admin_ai_query', 'Dokładne Zapytanie')}</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {loading ? (
              <Table.Tr><Table.Td colSpan={4} align="center"><Text>{t('loading', 'Ładowanie...')}</Text></Table.Td></Table.Tr>
            ) : logs.length === 0 ? (
              <Table.Tr><Table.Td colSpan={4} align="center"><Text>{t('no_data', 'Brak danych.')}</Text></Table.Td></Table.Tr>
            ) : (
              logs.map(log => (
                <Table.Tr key={log.id}>
                  <Table.Td style={{ whiteSpace: 'nowrap' }}>{new Date(log.requestTime).toLocaleString()}</Table.Td>
                  <Table.Td>{log.ownerEmail}</Table.Td>
                  <Table.Td>{log.model}</Table.Td>
                  <Table.Td>
                    <ScrollArea h={80} w={400}>
                      <Text size="xs" style={{ whiteSpace: 'pre-wrap' }}>{log.queryText}</Text>
                    </ScrollArea>
                  </Table.Td>
                </Table.Tr>
              ))
            )}
          </Table.Tbody>
        </Table>
      </ScrollArea>
    </Paper>
  );
}
